import React from "react";
import { Layout, Card } from 'antd';
import WebsiteIndexEntryTabs from '../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs';
import useGetCurrentWebsite from "../../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite";
import VisualSeoAnalysis from "../visualSeoAnalysis/VisualSeoAnalysis";
import useGetPlanSettings from "../../sales/hooks/useGetPlanSettings";
import DisabledFeature from "../../shared/DisabledFeature";
import LoadingIndicator from "../../components/shared/LoadingIndicator/LoadingIndicator";

const { Content } = Layout;


export default function VisualSeoAnalysisPage() {
    const { website: selectedWebsite } = useGetCurrentWebsite();
    const wGuid = selectedWebsite?.guid || "";
    const url = selectedWebsite?.homepage_url || "";
    const { allowVisualSeoAnalysis, isLoading: isLoadingPlanSettings } = useGetPlanSettings();

    return (
        <Content className="general-layout-content">
            {isLoadingPlanSettings && <LoadingIndicator />}
            {!isLoadingPlanSettings && !allowVisualSeoAnalysis && (
                <Card className="no-access">
                    <DisabledFeature />
                </Card>
            )}
            {(!isLoadingPlanSettings && allowVisualSeoAnalysis === true) && (
                <WebsiteIndexEntryTabs>
                    {wGuid && url ? <VisualSeoAnalysis wGuid={wGuid} url={url} /> : null}
                </WebsiteIndexEntryTabs>
            )}
        </Content>
    );
}